import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'mall',
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 多风格组件当前展示风格的id,对应config_default_value.typeList
    typeId: [Number, String]
  },
  data: function data() {
    return {
      previewDialog: false,
      previewSrc: '',
      previewName: ''
    };
  },
  computed: {
    typeItem: function typeItem() {
      var _this$item$config_def,
        _this = this;
      var typeList = ((_this$item$config_def = this.item.config_default_value) === null || _this$item$config_def === void 0 ? void 0 : _this$item$config_def.typeList) || [];
      return typeList.find(function (i) {
        return i.id + '' === _this.typeId + '';
      }) || {};
    },
    displayIcon: function displayIcon() {
      return this.typeItem.imageurl || this.item.icon;
    },
    displayName: function displayName() {
      return this.typeItem.title || this.item.widget_alias || this.item.widget;
    }
  },
  methods: {
    addPanel: function addPanel() {
      this.$emit('_addPanel', this.item);
      this.previewDialog = false;
    },
    onPreview: function onPreview(item) {
      this.previewSrc = item.icon;
      this.previewName = item.widget_alias || item.widget;
      this.previewDialog = true;
    }
  }
};